import { render } from "./HexEventCard.vue?vue&type=template&id=43565d34&scoped=true&ts=true"
import script from "./HexEventCard.vue?vue&type=script&lang=ts"
export * from "./HexEventCard.vue?vue&type=script&lang=ts"

import "./HexEventCard.vue?vue&type=style&index=0&id=43565d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43565d34"]])

export default __exports__